<template>
  <div class="mb-16">
    <CheckoutHeader :current-step="4" />
    <BaseContainer>
      <div
        class="md:mt-20 mb-10 flex flex-col-reverse md:flex-row gap-10 justify-between md:items-end"
      >
        <div class="flex-1 md:max-w-2xl">
          <h1 class="h2 mt-12 md:mt-2">
            {{ $t('checkout.thanks_for_your_order') }}
          </h1>
        </div>
      </div>

      <div
        class="flex flex-col md:flex-row gap-10 justify-between md:items-start pb-10"
      >
        <div class="flex-1 md:max-w-2xl">
          <div class="flex flex-col md:flex-row md:gap-4 mb-10">
            <CheckoutDownloadTickets />
            <CheckoutSaveToCalendar />
          </div>

          <div class="prose mb-10">
            <h4>{{ $t('checkout.ticket_buying_title') }}</h4>
            <p>{{ $t('checkout.ticket_buying_notice') }}</p>
            <p>
              {{
                $t('checkout.tickets_sent_to_email', {
                  email: cart.receiptOrder.info.email,
                })
              }}
            </p>
            <p>
              {{ $t('checkout.tickets_entry_notice') }}
            </p>
            <p>
              {{ $t('checkout.tickets_bank_statement') }}
            </p>
            <p>
              {{ $t('checkout.tickets_law_notice') }}
            </p>
            <p>
              {{ $t('checkout.tickets_see_terms') }}
              <button
                type="button"
                class="underline hover:opacity-70 transition-opacity"
                @click="termsModalOpen = true"
              >{{ $t('checkout.tickets_see_terms_link') }}</button>
            </p>
          </div>

          <BaseModal v-model="termsModalOpen" size="lg">
            <template #header>{{ $t('checkout.terms_label_header') }}</template>
            <div class="p-6">
              <CheckoutTermsContent />
            </div>
          </BaseModal>

          <div class="prose">
            <h4>{{ $t('checkout.questions') }}</h4>
            <p
              v-html="
                $t('checkout.questions_can_be_sent_to', {
                  email: customer.email,
                  phone: customer.telephone,
                })
              "
            ></p>
            <p>
              {{ $t('checkout.questions_order_number') }}
            </p>
          </div>

          <CheckoutReceiptInformation
            class="hidden md:block border-t border-surface-grey mt-10 pt-10"
          />
        </div>

        <div class="w-full md:w-120 md:max-w-1/2">
          <CheckoutReceipt />
        </div>

        <CheckoutReceiptInformation class="md:hidden" />
      </div>
    </BaseContainer>
  </div>
</template>

<script setup lang="ts">
  import { useHead } from '@unhead/vue';
  import { computed,onMounted, onUnmounted, ref } from 'vue';
  import { useI18n } from 'vue-i18n';

  import CheckoutDownloadTickets from '@/components/checkout/CheckoutDownloadTickets.vue';
  import CheckoutHeader from '@/components/checkout/CheckoutHeader.vue';
  import CheckoutReceipt from '@/components/checkout/CheckoutReceipt.vue';
  import CheckoutReceiptInformation from '@/components/checkout/CheckoutReceiptInformation.vue';
  import CheckoutSaveToCalendar from '@/components/checkout/CheckoutSaveToCalendar.vue';
  import CheckoutTermsContent from '@/components/checkout/CheckoutTermsContent.vue';
  import BaseContainer from '@/components/ui/BaseContainer.vue';
  import BaseModal from '@/components/ui/BaseModal.vue';
  import { useCartStore } from '@/stores/cart';
  import { useGeneralStore } from '@/stores/general';
  import type {  Customer} from '@/types';

  const { t } = useI18n();
  const generalStore = useGeneralStore();
  const customer = computed(() => generalStore.customer() as Customer);
  const cart = useCartStore();
  const termsModalOpen = ref(false);

  onMounted(() => {
    generalStore.fetchGeneral();
  });

  //When leaving we want to set receiptCart to false
  onUnmounted(() => {
    console.log('CheckoutReceipt unmounted, resetting receiptCart and cart2');
    cart.receiptCart = false;
    cart.resetCart();
  });

  useHead({
    title: t('checkout.thanks_for_your_order'),
    meta: [
      {
        property: 'og:title',
        content: t('checkout.thanks_for_your_order'),
      },
    ],
  });
</script>
